import React from 'react';
import './App.css';

import Main from './views/Main';
import {Navigator} from 'react-onsenui';

const renderPage = (route, navigator) => {
  return <route.component key={route.key} navigator={navigator} />
};

const App = () => {
  return (
    <Navigator
      renderPage={renderPage}
      initialRoute={{ component: Main, key: 'MAIN_PAGE' }}
    />
  );
}

export default App;
